import * as React from 'react';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import Redirect from 'legacy/components/util/Redirect/Redirect';
import Loader from 'legacy/common/components/layout/Loader';
import { Theme } from 'theme/survey-js/theme';
import Header from 'legacy/common/components/wysiwyg-form/Header';

import 'survey-core/survey-core.min.css';
import { useGetAssociationFormById } from 'api/queries/workflows/forms';
import { useRouter } from 'next/router';

const AssociationAdminFormView = () => {
  const router = useRouter();
  const { query } = router;
  const associationId = query.associationId as string;
  const formId = query.formId as string;

  const { data, isLoading, isError } = useGetAssociationFormById({
    associationId,
    formId
  });

  if (isLoading) {
    return <Loader isLoading />;
  }

  if (isError || !data?.schema) {
    return <Redirect to="/404" />;
  }

  const survey = new Model(data.schema);
  survey.applyTheme(Theme);

  // Configure preview mode settings - completely disable validation for navigation
  survey.checkErrorsMode = 'onComplete';
  survey.showNavigationButtons = true;
  survey.showPrevButton = true;
  survey.showCompleteButton = false;

  survey.hasErrors = () => false;

  survey.onCurrentPageChanging.add((sender, options) => {
    options.allow = true;
  });

  survey.onUploadFiles.add((sender: any, options: any) => {
    const mockResponse = options.files.map((file: File) => ({
      file,
      content: `mock-preview-url-${file.name}`
    }));

    setTimeout(() => {
      options.callback(mockResponse);
    }, 200);
  });

  survey.onClearFiles.add((sender: any, options: any) => {
    options.callback('success', []);
  });

  return (
    <>
      <Header
        isDraft={false}
        title={data.name}
        isLoading={isLoading}
        onBack={() =>
          router.push(`/associations/${associationId}/settings/forms`)
        }
      />
      <FadeIn>
        <div className="pt-[50px] md:pt-[120px] -mt-[90px] pb-20">
          <Survey model={survey} />
        </div>
      </FadeIn>
    </>
  );
};

export default AssociationAdminFormView;
